const iconMappings = [
  { iconName: 'Sun', numbers: [1, 2, 5] },
  { iconName: 'Partly-Cloudy', numbers: [3, 4] },
  { iconName: 'Cloudy', numbers: [6, 38] },
  { iconName: 'Cloud', numbers: [7, 8] },
  { iconName: 'Fog', numbers: [11] },
  { iconName: 'Shower-2', numbers: [12, 14] },
  { iconName: 'Rain', numbers: [13, 18, 26, 40] },
  { iconName: 'Thunder', numbers: [15, 16, 42] },
  { iconName: 'Partly-Thunder', numbers: [17] },
  { iconName: 'Snow', numbers: [19, 20, 22, 23, 43, 44] },
  { iconName: 'Snow-Shower', numbers: [21] },
  { iconName: 'Snowflake', numbers: [24] },
  { iconName: 'Rain-and-Snow', numbers: [25, 29] },
  { iconName: 'Hot', numbers: [30] },
  { iconName: 'Cold', numbers: [31] },
  { iconName: 'Wind', numbers: [32] },
  { iconName: 'Moon', numbers: [33, 34, 37] },
  { iconName: 'Partly-Cloudy-Night', numbers: [35, 36] },
  { iconName: 'Shower-Night', numbers: [39] },
  { iconName: 'Partly-Thunder-Night', numbers: [41] }
]

export default iconMappings as { iconName: string; numbers: number[] }[]
